import React from "react";

const AdCard = ({ ad }) => {
    return (
        <div
            className="p-4 overflow-hidden duration-300 border bg-bg-light-secondary border-border-light rounded-xl hover:shadow-glow dark:bg-bg-dark-secondary dark:border-border-dark"
        >
            {/* Banner */}
            <div className="overflow-hidden rounded-lg">
                <img
                    src={ad?.banner}
                    alt={ad?.companyName}
                    className="object-cover w-full h-40 transition-transform duration-500 group-hover:scale-105"
                />
            </div>

            {/* Footer */}
            <div className="flex items-center gap-3 pt-4">
                <img
                    src={ad?.logo}
                    alt={ad?.companyName}
                    className="w-8 h-8 border rounded-full dark:border-primary border-primary-light"
                />

                <p className="text-sm font-medium text-black dark:text-white">
                    {ad?.companyName}
                </p>
            </div>
        </div>
    );
};

export default AdCard;
